














import { Component, Watch } from 'vue-property-decorator';
import MenuBase from './menu-base';
import UrlMixin, { ExcludeTypeEnum } from '@/components/query/url-mixin';
import { AclMixin } from '@/components/acl/acl-mixin';
import { mixins } from 'vue-class-component';
import { has, camelCase } from 'lodash';
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import MenuReportActionsMixin, { MenuReportRowAction } from '@/views/layout/navigation/mixins/menu-report-actions-mixin';
import tutorial from '@/components/tutorial/tutorial';

@Component
export default class MenuReportContextMenu extends mixins(MenuReportActionsMixin) {
  showContextMenu: boolean = false;
  menuTop: number = 0;
  menuLeft: number = 0;

  get contextMenu(): MenuReportRowAction[] {
    return [
      this.itemActions.drilldownHome,
      this.itemActions.drilldown,
      this.itemActions.excludeHome,
      this.itemActions.exclude,
      this.itemActions.edit
    ].concat(this.itemMenu as any[]);
  }

  get contextMenuFiltered() {
    return this.contextMenu
      .filter((item) => typeof item.showCondition === 'undefined' || item.showCondition);
  }

  mounted() {
    const { bus } = this;

    bus.on('row-contextmenu', this.onBusContextMenu);
    bus.on('clear-row-context', this.onBusClearRowContext);
  }

  beforeDestroy() {
    const { bus } = this;

    bus.off('row-contextmenu', this.onBusContextMenu);
    bus.off('clear-row-context', this.onBusClearRowContext);
  }

  onBusContextMenu(data: any, top: any, left: any) {
    this.rowContextMenu(data, top, left);
  }

  onBusClearRowContext() {
    this.showContextMenu = false;
  }

  rowContextMenu(data: any, top: number, left: number) {
    this.showContextMenu = false;

    this.$nextTick(() => {
      this.showContextMenu = true;
      this.menuTop = top;
      this.menuLeft = left;
    });
  }
}
